(function(){
'use strict';
var LOCATION_CACHE='profind_approx_location_v1';
var LOCATION_TTL=24*60*60*1000;
var PRECISE_SESSION_CACHE='profind_precise_location_v1';
var preciseLocationInFlight=null;

function normalizePreciseLocation(value){
  if(!value)return null;
  var lat=Number(value.lat!=null?value.lat:value.latitude);
  var lng=Number(value.lng!=null?value.lng:value.longitude);
  if(!isFinite(lat)||!isFinite(lng))return null;
  return{
    label:String(value.label||'Your current location'),
    lat:lat,
    lng:lng,
    latitude:lat,
    longitude:lng,
    accuracy:value.accuracy==null?null:Number(value.accuracy),
    source:'gps',
    precise:true,
    saved_at:Number(value.saved_at||Date.now())
  };
}
function readPreciseLocation(){
  try{
    var raw=sessionStorage.getItem(PRECISE_SESSION_CACHE);
    if(raw){
      var cached=normalizePreciseLocation(JSON.parse(raw));
      if(cached)return cached;
    }
  }catch(e){}
  try{
    var shared=sessionStorage.getItem('pfm_location');
    if(shared){
      var parsed=JSON.parse(shared);
      if(parsed&&parsed.source==='gps'){
        var loc=normalizePreciseLocation(parsed);
        if(loc)return loc;
      }
    }
  }catch(e){}
  return null;
}
function storePreciseLocation(value){
  var loc=normalizePreciseLocation(value);
  if(!loc)return null;
  loc.saved_at=Date.now();
  try{
    sessionStorage.setItem(PRECISE_SESSION_CACHE,JSON.stringify(loc));
    sessionStorage.setItem('pfm_location',JSON.stringify({
      label:loc.label,
      lat:loc.lat,
      lng:loc.lng,
      accuracy:loc.accuracy,
      source:'gps',
      precise:true,
      saved_at:loc.saved_at
    }));
    if(!sessionStorage.getItem('pfm_radius'))sessionStorage.setItem('pfm_radius','15');
  }catch(e){}
  window.ProFindPreciseLocation=loc;
  try{window.dispatchEvent(new CustomEvent('profind:precise-location',{detail:loc}))}catch(e){}
  return loc;
}
function getPreciseLocation(options){
  options=options||{};
  var cached=readPreciseLocation();
  if(cached&&!options.force)return Promise.resolve(cached);
  if(preciseLocationInFlight)return preciseLocationInFlight;
  if(!navigator.geolocation){
    var unavailable=new Error('Location services are unavailable.');
    unavailable.code='UNAVAILABLE';
    return Promise.reject(unavailable);
  }
  preciseLocationInFlight=new Promise(function(resolve,reject){
    navigator.geolocation.getCurrentPosition(function(pos){
      var c=pos&&pos.coords;
      if(!c){
        var invalid=new Error('Location could not be confirmed.');
        invalid.code='INVALID';
        reject(invalid);
        return;
      }
      var base={
        label:'Precise location',
        latitude:c.latitude,
        longitude:c.longitude,
        accuracy:c.accuracy
      };
      var client=getClient();
      if(client){
        client.rpc('profind_nearest_place',{
          target_lat:Number(c.latitude),
          target_lon:Number(c.longitude),
          max_km:50
        }).then(function(r){
          var p=r&&r.data&&r.data[0]||null;
          if(p){
            var parts=[p.name];
            if(p.municipality&&String(p.municipality).toLowerCase()!=='midvaal')parts.push(p.municipality);
            else if(String(p.name||'').toLowerCase()!=='meyerton')parts.push('Meyerton');
            if(p.province)parts.push(p.province);
            base.label=parts.filter(Boolean).filter(function(v,i,a){return a.indexOf(v)===i}).join(', ');
          }
          var loc=storePreciseLocation(base);
          if(!loc){var invalid=new Error('Location could not be confirmed.');invalid.code='INVALID';reject(invalid);return}
          resolve(loc);
        }).catch(function(){
          var loc=storePreciseLocation(base);
          if(!loc){var invalid=new Error('Location could not be confirmed.');invalid.code='INVALID';reject(invalid);return}
          resolve(loc);
        });
      }else{
        var loc=storePreciseLocation(base);
        if(!loc){var invalid=new Error('Location could not be confirmed.');invalid.code='INVALID';reject(invalid);return}
        resolve(loc);
      }
    },function(err){
      var e=new Error('Location could not be confirmed.');
      e.code=err&&err.code===1?'DENIED':err&&err.code===3?'TIMEOUT':'UNAVAILABLE';
      reject(e);
    },{
      enableHighAccuracy:true,
      timeout:20000,
      maximumAge:0
    });
  }).then(function(loc){
    preciseLocationInFlight=null;
    return loc;
  },function(err){
    preciseLocationInFlight=null;
    throw err;
  });
  return preciseLocationInFlight;
}
window.ProFindLocation={
  get:getPreciseLocation,
  peek:readPreciseLocation,
  set:storePreciseLocation
};


function esc(v){return String(v==null?'':v).replace(/[&<>"']/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]})}
function shortArea(v){return String(v||'').split(',')[0].trim()}
function getClient(){return window.ProFindData&&window.ProFindData.client?window.ProFindData.client():null}
function readSessionLocation(){try{var raw=sessionStorage.getItem('pfm_location');return raw?JSON.parse(raw):null}catch(e){return null}}
function writeSessionLocation(loc){try{sessionStorage.setItem('pfm_location',JSON.stringify(loc));if(!sessionStorage.getItem('pfm_radius'))sessionStorage.setItem('pfm_radius','15')}catch(e){}}
function readApproxCache(){try{var raw=localStorage.getItem(LOCATION_CACHE);if(!raw)return null;var x=JSON.parse(raw);if(!x||!x.saved_at||Date.now()-Number(x.saved_at)>LOCATION_TTL)return null;return x.location||null}catch(e){return null}}
function writeApproxCache(loc){try{localStorage.setItem(LOCATION_CACHE,JSON.stringify({saved_at:Date.now(),location:loc}))}catch(e){}}
function decorateApprox(loc){
  if(!loc||loc.source!=='ip')return;
  var area=shortArea(loc.label)||'Near you';
  var pill=document.getElementById('pfm-locpill-text');if(pill)pill.textContent=area+' · Approx.';
  var pulse=document.getElementById('pfe-pulse-place');if(pulse)pulse.textContent=area+' · Approx.';
  var radius=document.getElementById('pfe-pulse-radius');if(radius&&radius.textContent.indexOf('Approx')<0)radius.textContent='Approximate area · 25 km';
}
function announceLocation(loc){
  window.ProFindApproxLocation=loc;
  try{window.dispatchEvent(new CustomEvent('profind:approx-location',{detail:loc}))}catch(e){}
  [0,350,1200,2600].forEach(function(ms){setTimeout(function(){decorateApprox(loc)},ms)});
}
function seedAndMaybeReload(loc){
  if(!loc)return;
  var before=readSessionLocation();
  if(before){announceLocation(before);return}
  writeSessionLocation(loc);
  announceLocation(loc);
  var discovery=document.getElementById('pfm-marketplace')||document.getElementById('pfe-home');
  if(discovery){
    try{
      if(sessionStorage.getItem('profind_ip_seed_reload')!=='1'){
        sessionStorage.setItem('profind_ip_seed_reload','1');
        window.location.reload();
      }
    }catch(e){}
  }
}
function normalizeIp(data){
  var lat=Number(data&&data.latitude),lng=Number(data&&data.longitude);
  if(!isFinite(lat)||!isFinite(lng))return null;
  var city=String(data.city||'').trim(),region=String(data.region||data.region_name||'').trim();
  var label=city||region||'Your area';
  if(city&&region&&city.toLowerCase()!==region.toLowerCase())label=city+', '+region;
  return{label:label,lat:lat,lng:lng,source:'ip',approximate:true};
}
function bootApproxLocation(){
  var existing=readSessionLocation();
  if(existing){announceLocation(existing);return}
  var cached=readApproxCache();
  if(cached){seedAndMaybeReload(cached);return}
  fetch('https://ipapi.co/json/',{headers:{Accept:'application/json'},cache:'no-store'})
    .then(function(r){if(!r.ok)throw new Error('location unavailable');return r.json()})
    .then(function(data){var loc=normalizeIp(data);if(!loc)return;writeApproxCache(loc);seedAndMaybeReload(loc)})
    .catch(function(){});
}

function waitForData(fn,attempt){
  attempt=attempt||0;
  if(window.ProFindData&&getClient()){fn();return}
  if(attempt>80)return;
  setTimeout(function(){waitForData(fn,attempt+1)},100);
}

var pfOfficialEmergencyLoading=false;
function officialEmergency(){
  var intro=document.getElementById('pfhn-panel-intro');
  if(!intro||document.getElementById('pf-official-emergency')||pfOfficialEmergencyLoading)return;
  pfOfficialEmergencyLoading=true;
  waitForData(function(){
    var client=getClient();
    if(!client){pfOfficialEmergencyLoading=false;return;}
    client.from('emergency_contact_shortcuts')
      .select('code,label,phone_number,description,scope,sort_order,is_active,last_verified_on')
      .eq('is_active',true).order('sort_order',{ascending:true})
      .then(function(res){
        var rows=res.data||[];
        pfOfficialEmergencyLoading=false;
        if(res.error||!rows.length||document.getElementById('pf-official-emergency'))return;
        var box=document.createElement('div');box.id='pf-official-emergency';box.className='pfaddon-emergency';
        box.innerHTML='<div class="pfaddon-emergency__head"><span>Life-threatening emergency?</span><strong>Call official emergency services now.</strong><small>ProFind Emergency connects you to urgent local service providers. It does not replace Police, Ambulance, Fire or Rescue.</small></div>'+
          '<div class="pfaddon-emergency__grid">'+rows.map(function(x){
            return '<a href="tel:'+esc(x.phone_number)+'"><span>'+esc(x.label)+'</span><strong>'+esc(x.phone_number)+'</strong></a>';
          }).join('')+'</div>';
        var note=intro.querySelectorAll('.pfhn-note');var anchor=note.length?note[note.length-1]:intro.querySelector('#pfhn-cancel');
        if(anchor&&anchor.parentNode)anchor.parentNode.insertBefore(box,anchor.nextSibling);else intro.appendChild(box);
        var old=Array.prototype.slice.call(intro.querySelectorAll('.pfhn-note')).filter(function(n){return /police, fire or medical emergencies/i.test(n.textContent||'')})[0];
        if(old)old.style.display='none';
      }).catch(function(){pfOfficialEmergencyLoading=false;});
  });
}

function statusLabel(v){
  return{PENDING_REVIEW:'Pending review',VERIFIED:'Verified',NEEDS_ATTENTION:'Needs attention',REJECTED:'Not approved',EXPIRED:'Expired'}[String(v||'').toUpperCase()]||String(v||'');
}
function currentBusiness(){
  return window.ProFindData.getMyBusinesses().then(function(r){
    var rows=r&&r.data||[],id=rows[0]&&rows[0].business&&rows[0].business.id;
    if(!id)throw new Error('Business context unavailable');
    return window.ProFindData.getBusinessFull(id).then(function(full){
      if(full&&full.error)throw full.error;
      return{id:id,plan:String(full&&full.data&&full.data.plan||rows[0].business.plan||'FREE').toUpperCase()};
    });
  });
}
function certSection(){
  var root=document.getElementById('pfbo2-root'),section=document.getElementById('pfbo2-section-certifications');
  if(!root||!section||section.dataset.pfCertMounted)return;
  section.dataset.pfCertMounted='1';
  var body=section.querySelector('[data-pfbo-body]')||section;
  waitForData(function(){
    currentBusiness().then(function(ctx){
      if(ctx.plan==='FREE'){
        body.innerHTML='<div class="pfaddon-lock"><strong>Industry Certifications are available on Standard and Pro.</strong><span>Upload trade, professional and industry-specific certificates to strengthen customer trust. Existing certification records are kept safely if you downgrade, but they are hidden while your business is on Free.</span><a href="#pfbo2-section-membership">View upgrade options</a></div>';
        var prog=document.getElementById('pfbo2-progress-certifications');if(prog)prog.textContent='Standard + Pro';
        return;
      }
      body.innerHTML='<div class="pfaddon-cert-head"><div><strong>Industry Certifications</strong><span>Add credentials relevant to your trade or profession. Uploads are private until ProFind reviews them.</span></div><button type="button" class="pfbo2-btn pfbo2-btn--primary" id="pf-cert-add">+ Add new certification</button></div>'+
        '<form id="pf-cert-form" class="pfaddon-cert-form" hidden><label>Certification name<input id="pf-cert-name" maxlength="160" required placeholder="e.g. Electrical Wireman’s Licence"></label><label>Certificate file<input id="pf-cert-file" type="file" accept=".pdf,image/jpeg,image/png,image/webp" required></label><div class="pfaddon-cert-actions"><button class="pfbo2-btn pfbo2-btn--primary" type="submit">Submit for review</button><button class="pfbo2-btn" type="button" id="pf-cert-cancel">Cancel</button></div><p id="pf-cert-msg" class="pfbo2-fineprint" aria-live="polite"></p></form>'+
        '<div id="pf-cert-list"><div class="pfbo2-state">Loading certifications…</div></div>'+
        '<p class="pfbo2-fineprint">Only certifications reviewed and marked <strong>Verified</strong> by ProFind are shown to customers. The uploaded document itself stays private.</p>';
      var add=document.getElementById('pf-cert-add'),form=document.getElementById('pf-cert-form'),cancel=document.getElementById('pf-cert-cancel'),msg=document.getElementById('pf-cert-msg'),list=document.getElementById('pf-cert-list');
      function load(){
        getClient().from('business_certifications')
          .select('id,business_id,certification_name,status,is_active,verified_at,review_note,created_at,updated_at')
          .eq('business_id',ctx.id).order('created_at',{ascending:false}).then(function(res){
            var rows=res.data||[];
            var prog=document.getElementById('pfbo2-progress-certifications');if(prog)prog.textContent=rows.length?(rows.length+' credential'+(rows.length===1?'':'s')):'No certifications yet';
            if(res.error){list.innerHTML='<div class="pfbo2-state">Could not load certifications right now.</div>';return}
            if(!rows.length){list.innerHTML='<div class="pfaddon-cert-empty"><strong>No certifications added yet.</strong><span>Add the credentials customers should know about.</span></div>';return}
            list.innerHTML=rows.map(function(x){
              var cls=String(x.status||'').toLowerCase().replace(/_/g,'-');
              return '<article class="pfaddon-cert-row"><div><strong>'+esc(x.certification_name)+'</strong><span class="pfaddon-cert-status pfaddon-cert-status--'+esc(cls)+'">'+esc(statusLabel(x.status))+'</span>'+(x.review_note?'<small>'+esc(x.review_note)+'</small>':'')+'</div><div class="pfaddon-cert-row__actions"><button type="button" data-cert-open="'+esc(x.id)+'">View upload</button><button type="button" data-cert-delete="'+esc(x.id)+'">Remove</button></div></article>';
            }).join('');
          });
      }
      add.addEventListener('click',function(){form.hidden=false;add.disabled=true;document.getElementById('pf-cert-name').focus()});
      cancel.addEventListener('click',function(){form.hidden=true;add.disabled=false;form.reset();msg.textContent=''});
      form.addEventListener('submit',function(ev){
        ev.preventDefault();var name=document.getElementById('pf-cert-name').value.trim(),file=document.getElementById('pf-cert-file').files[0],btn=form.querySelector('[type=submit]');
        if(!name||!file)return;
        if(file.size>12*1024*1024){msg.textContent='Choose a file smaller than 12 MB.';return}
        var fd=new FormData();fd.append('business_id',ctx.id);fd.append('certification_name',name);fd.append('certificate',file);
        btn.disabled=true;btn.textContent='Uploading…';msg.textContent='';
        getClient().functions.invoke('upload-business-certification',{body:fd}).then(function(res){
          btn.disabled=false;btn.textContent='Submit for review';
          if(res.error||!res.data||!res.data.ok){msg.textContent=(res.data&&res.data.error)||'We could not upload this certification. Please try again.';return}
          msg.textContent='Certification submitted for ProFind review.';form.reset();setTimeout(function(){form.hidden=true;add.disabled=false;msg.textContent=''},900);load();
        }).catch(function(){btn.disabled=false;btn.textContent='Submit for review';msg.textContent='We could not upload this certification. Please try again.'});
      });
      list.addEventListener('click',function(ev){
        var open=ev.target.closest('[data-cert-open]'),del=ev.target.closest('[data-cert-delete]');
        if(open){
          open.disabled=true;msg.textContent='Opening secure document…';
          getClient().functions.invoke('manage-business-certification',{body:{action:'GET_DOCUMENT_URL',certification_id:open.getAttribute('data-cert-open')}}).then(function(res){
            open.disabled=false;
            if(res.data&&res.data.url){msg.textContent='';window.open(res.data.url,'_blank','noopener');}
            else msg.textContent=(res.data&&res.data.error)||'Could not open this certificate.';
          }).catch(function(){open.disabled=false;msg.textContent='Could not open this certificate.'});
        }
        if(del){
          var remove=function(){
            del.disabled=true;msg.textContent='Removing certification…';
            return getClient().functions.invoke('manage-business-certification',{body:{action:'DELETE',certification_id:del.getAttribute('data-cert-delete')}}).then(function(res){
              if(res.error||!res.data||!res.data.ok){del.disabled=false;msg.textContent=(res.data&&res.data.error)||'Could not remove this certification.';return false}
              msg.textContent='Certification removed.';load();return true;
            }).catch(function(){del.disabled=false;msg.textContent='Could not remove this certification.';return false});
          };
          if(window.ProFindPrompt){
            window.ProFindPrompt({
              title:'Remove certification?',
              message:'This removes the certification record and its uploaded document from your business workspace.',
              fields:[],
              confirmLabel:'Remove certification',
              cancelLabel:'Keep certification',
              danger:true
            }).then(function(values){if(values!==null)return remove()}).catch(function(){});
          }else{
            msg.textContent='Confirmation could not open. Refresh the page and try again.';
          }
        }
      });
      load();
    }).catch(function(){body.innerHTML='<div class="pfbo2-state">Certification tools could not load. Refresh and try again.</div>'});
  });
}
function planSummary(){
  var root=document.getElementById('pfbo2-root');if(!root)return;
  waitForData(function(){
    currentBusiness().then(function(ctx){
      var host=document.querySelector('#pfbo2-section-membership [data-pfbo-body]');if(!host)return;
      var old=document.getElementById('pf-plan-feature-summary');if(old)old.remove();
      var box=document.createElement('section');box.id='pf-plan-feature-summary';box.className='pfaddon-plan-summary';
      box.innerHTML='<div class="pfaddon-plan-summary__head"><strong>Your ProFind plan features</strong><span>Current: '+esc(ctx.plan.charAt(0)+ctx.plan.slice(1).toLowerCase())+'</span></div>'+
      '<div class="pfaddon-plan-grid">'+
      '<article><img src="https://cdn.shopify.com/s/files/1/1017/9081/0429/files/profind-demand-watch-feature.png?v=1790499174" alt="Demand Watch" style="display:block;width:112px;max-width:100%;height:auto;margin:0 0 7px"><b>FREE · R0</b><span>Demand Watch locked · upgrade to Standard for Market Signals or Pro for full Demand Intelligence · 1 photo · 1 service area · search listing · enquiries & reviews · basic analytics</span></article>'+
      '<article><img src="https://cdn.shopify.com/s/files/1/1017/9081/0429/files/profind-demand-watch-feature.png?v=1790499174" alt="Demand Watch" style="display:block;width:112px;max-width:100%;height:auto;margin:0 0 7px"><b>STANDARD · R115/month</b><span>Demand Watch Market Signals · Demand Pulse + basic live opportunities · 6 photos · 5 areas · 1 offer · Industry Certifications · Emergency Response + Emergency WhatsApp · enhanced analytics · premium profile · Reserve™ not included</span></article>'+
      '<article><img src="https://cdn.shopify.com/s/files/1/1017/9081/0429/files/profind-demand-watch-feature.png?v=1790499174" alt="Demand Watch" style="display:block;width:112px;max-width:100%;height:auto;margin:0 0 7px"><b>PRO · R575/month</b><span>Demand Watch+ · live spare-capacity matching + deeper demand intelligence · 12 photos · 20 areas · 5 offers · Industry Certifications · NOW AI · full Reserve™ · FeeShield™ · team Emergency Dispatch · Emergency + lead WhatsApp · followers · scheduling · advanced analytics & Growth Intelligence</span></article>'+
      '</div>';
      host.appendChild(box);
    }).catch(function(){});
  });
}
function keepPlanSummary(){
  planSummary();
  [1200,2800,5200].forEach(function(ms){setTimeout(planSummary,ms)});
}
function publicCerts(){
  var root=document.querySelector('.pfl');if(!root||document.getElementById('pfl-certifications'))return;
  var slug=new URLSearchParams(window.location.search).get('business');if(!slug)return;
  waitForData(function(){
    window.ProFindData.getPublicBusiness(slug).then(function(bres){
      var b=bres&&bres.data;if(!b||!b.id)return;
      return getClient().from('business_certifications')
        .select('id,certification_name,status,verified_at').eq('business_id',b.id).eq('status','VERIFIED').eq('is_active',true).order('verified_at',{ascending:false})
        .then(function(res){
          var rows=res.data||[];if(res.error||!rows.length)return;
          var aside=document.querySelector('.pfl__aside');if(!aside)return;
          var card=document.createElement('section');card.className='pfl__card pfaddon-public-certs';card.id='pfl-certifications';
          card.innerHTML='<div class="pfaddon-public-certs__title"><span>✓</span><div><small>PROFIND REVIEWED</small><h2>Industry certifications</h2></div></div>'+
            '<div class="pfaddon-public-cert-list">'+rows.map(function(x){return '<div><strong>'+esc(x.certification_name)+'</strong><span>Verified by ProFind</span></div>'}).join('')+'</div>';
          aside.insertBefore(card,aside.firstChild);
        });
    }).catch(function(){});
  });
}

function boot(){
  var existing=readSessionLocation();
  if(!existing||existing.source==='ip'||existing.approximate===true){
    getPreciseLocation({force:true}).catch(function(){bootApproxLocation()});
  }else{
    announceLocation(existing);
  }
  officialEmergency();
  certSection();
  keepPlanSummary();
  publicCerts();
  setTimeout(officialEmergency,1200);
  setTimeout(certSection,1600);
  setTimeout(publicCerts,1800);
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();